module.exports = __webpack_public_path__ + "img/i4.a897e8fd.png";